/* istanbul ignore file */
import React from 'react';
import SingleServiceCatalogBreadcrumbs from 'domain/organization/serviceCatalog/shared/SingleServiceCatalogBreadcrumbs';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useServiceCatalogId } from 'domain/organization/serviceCatalog/useServiceCatalogId';
import { useServiceCatalogUrl } from 'domain/shared/serviceCatalog';

const ListKpiValuesBreadcrumbs = ({ children }: { children?: React.ReactElement | React.ReactElement[] }) => {
  const id = useServiceCatalogId();
  const { getCostsStructuresUrl } = useServiceCatalogUrl();

  return (
    <SingleServiceCatalogBreadcrumbs>
      <SingleBreadcrumbItem entity="KPI Values" link={getCostsStructuresUrl(id)} />
      {children}
    </SingleServiceCatalogBreadcrumbs>
  );
};

export default ListKpiValuesBreadcrumbs;
